import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { BASEPATH } from './env/variables';
const EN = "en-US";
// const ES = "es-ES";
export const defaultLanguage = EN;

const fallbackLng = [defaultLanguage];
// const availableLanguages = [EN, ES];
const loadPath =
  process.env.REACT_APP_ENV === "production"
    ? `/locales/{{lng}}/{{ns}}.json`
    : `/locales/{{lng}}/{{ns}}.json`;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: defaultLanguage,
    fallbackLng,
    // whitelist: availableLanguages,
    nonExplicitWhitelist: true,
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    backend: {
      loadPath
    }
  });

export default i18n;
